import ThumbprintText from "./ThumbprintText";
export default ThumbprintText;
